import type { CustomerWebhook } from './customer-webhooks.model';

export function transformCustomerWebhook(
  response: CustomerWebhook,
): CustomerWebhook {
  return response;
}
